import React, { useEffect, useState } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Logo from "../../../components/_Atoms/Logo"
import LogoIcon from "../../../components/_Atoms/LogoIcon"
import CustomLink from "../../_Atoms/CustomLink"
import Modal from "../../Modal"
import { downloadModalContent } from "../../../helpers/downloadsData"

export default function Header() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const [position, setPosition] = useState(0)
  const [visible, setVisible] = useState(true)

  const data = useStaticQuery(graphql`
    query Header {
    contentfulSiteOptions {
      reportTitle,
      reportIntro {
        raw
       },
      fullReportThumbnail {
        file {
          url
        },
       description
      },
      sustainabilityBrochureTitle,
      sustainabilityIntro {
        raw
       },
      sustainabilityThumbnail {
        file {
          url
        },
        description,
      },
    }
  }
  `)

  useEffect(() => {
    const handleScroll = () => {
      let moving = window.pageYOffset

      setVisible(position >= moving)
      setPosition(moving)
    }

    if (position === 0) {
      setVisible(true)
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [position])

  const cls = visible ? "translate-y-0" : "-translate-y-full"


  return (
    <>
      <Modal
        isModalOpen={isModalOpen}
        modalContent={modalContent}
        setIsModalOpen={setIsModalOpen}
      />
      <header
        className={`has-before-gradient transition duration-300 top-0 left-0 right-0 w-full bg-lcygray-500 ${cls} z-50`}
      >
        <div className="container py-4 horizontal-padding">
          <div className="flex items-center justify-between lg:w-full">
            <Link
              className="block w-24 text-lg font-bold h-[47px] md:text-xl lg:max-w-[283px] lg:h-auto lg:w-full"
              aria-label="Go to homepage"
              to="/"
            >
              <Logo className="hidden lg:flex" />
              <LogoIcon className="lg:hidden" />
            </Link>
            <CustomLink
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setModalContent={setModalContent}
              content={downloadModalContent(data.contentfulSiteOptions)}
              type="modal"
              label="Download our Reports"
            />
          </div>
        </div>
      </header>
    </>
  )
}

